let MISC = {};

MISC.init = function () {
  fixFlexOnSamsung();
};

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
MISC.debounce = function (func, wait, immediate) {
  let timeout;
  return function () {
    let context = this;
    let args = arguments;
    let later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

// This function corrects the problem on Samsung Browser when using flex property
function fixFlexOnSamsung() {
  if (navigator.userAgent.match(/SamsungBrowser/i)) {
    $('.main__wrapper').css('flex', 'initial');
  }
}

window.imageError = function (elem) {
  elem.setAttribute('style', 'display:none');
};

export default MISC;
